// NOTE: Bu metin bir taslaktır. Hukuki kontrol önerilir.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function TermsOfService() {
  return (
    <LegalPage
      title="Kullanım Koşulları"
      subtitle="uSeen platformunu kullanmadan önce bu koşulları okumanızı rica ederiz."
      lastUpdated="Mayıs 2026"
      version={LEGAL_VERSIONS.terms}
      testid="terms-page"
    >
      <h2>1. Hizmetin Tanımı</h2>
      <p>
        uSeen, yerel işletmelerin yapay zekâ asistanları (ChatGPT, Claude, Gemini ve
        benzeri büyük dil modelleri) tarafından doğru biçimde bulunabilmesini kolaylaştıran
        bir <strong>AI görünürlük hazırlık ve analiz platformudur</strong>. uSeen,
        web sitesi içeriği, teknik sinyaller ve sektörel sorular üzerinden bir görünürlük
        skoru üretir ve iyileştirme önerileri sunar.
      </p>

      <h2>2. Garanti Sınırı</h2>
      <p>
        uSeen, hiçbir arama motorunda veya AI asistanında <strong>belirli bir sıralama,
        konum veya görünürlük garantisi vermez</strong>. Platformun ürettiği skorlar,
        görevler ve içerik önerileri yalnızca rehber niteliğindedir; sonuçlar
        kullanıcının uygulama hızına, sektör rekabetine ve üçüncü taraf algoritmalara
        bağlıdır.
      </p>

      <h2>3. Hesap ve Doğru Bilgi</h2>
      <p>
        Hesap oluştururken sağladığınız e-posta, ad-soyad, işletme bilgileri ve web sitesi
        adresinin <strong>doğru ve güncel</strong> olması sizin sorumluluğunuzdadır.
        Yanlış veya yanıltıcı bilgi tespit edilirse hesabınız askıya alınabilir.
      </p>

      <h2>4. Planlar ve Kullanım Limitleri</h2>
      <p>
        uSeen, Free Check / Starter / Growth / Pro / uSeen Assist olmak üzere farklı
        paketler sunar. Her paketin işletme sayısı, aylık içerik üretimi, yeniden
        tarama ve AI soru testi limitleri farklıdır. Limitler{" "}
        <a href="/fiyatlandirma">Fiyatlandırma</a> sayfasında detaylıdır ve önceden
        haber verilerek güncellenebilir.
      </p>

      <h2>5. Hesap Güvenliği</h2>
      <p>
        Şifrenizin gizliliğinden ve hesabınız üzerinden yapılan tüm işlemlerden siz
        sorumlusunuz. Şifrenizi paylaşmamanızı ve hesabınızda şüpheli bir durum
        gözlemlerseniz derhâl uSeen ile iletişime geçmenizi öneririz.
      </p>

      <h2>6. Yasaklı Kullanım</h2>
      <ul>
        <li>Başkasına ait işletme bilgilerini izinsiz kaydetmek</li>
        <li>Yanıltıcı veya yanlış işletme bilgisi girmek</li>
        <li>Platformun kullanım kotalarını aşmak amacıyla otomatik araç kullanmak</li>
        <li>Üretilen içeriği kötü niyetli ya da yanıltıcı amaçlarla kullanmak</li>
        <li>Üçüncü taraflara zarar verecek veya hukuka aykırı içerik üretmek</li>
      </ul>
      <p>Yukarıdaki davranışlar hesabın askıya alınması veya kapatılmasıyla sonuçlanabilir.</p>

      <h2>7. Sorumluluk Sınırlaması</h2>
      <p>
        uSeen, hizmet kesintileri, üçüncü taraf değişiklikleri veya AI modellerinin
        ürettiği sonuçların yorumlanması nedeniyle doğabilecek dolaylı zararlardan
        sorumlu tutulamaz. uSeen'in toplam sorumluluğu, ilgili kullanıcının son 12 ay
        içinde uSeen'e ödediği toplam ücretle sınırlıdır.
      </p>

      <h2>8. Hizmette Değişiklik</h2>
      <p>
        uSeen, platformun özelliklerini ve bu Kullanım Koşulları'nı zaman içinde
        güncelleyebilir. Önemli değişikliklerde kullanıcılar bilgilendirilir.
      </p>

      <h2>9. Uygulanacak Hukuk</h2>
      <p>
        Bu Koşullar Türkiye Cumhuriyeti mevzuatına tabidir. Uyuşmazlıkların çözümünde
        İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.
      </p>

      <h2>10. İletişim</h2>
      <p>
        Koşullarla ilgili sorularınız için <a href="/iletisim">iletişim sayfası</a>
        üzerinden bize ulaşabilirsiniz.
      </p>
    </LegalPage>
  );
}
